<section id="profile-info">
                <div class="row">
                    <div class="col-lg-12 col-12 order-1 order-lg-2">
                        <div class="form-group mb-2">
                            <div class="card">
                                <div class="card-header">
                                    <h2>{{blockLabel}}</h2>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="icon">Icon</label>
                                                <select class="form-control" id="icon" [(ngModel)]="icon"
                                                        name="icon">
                                                    <option value="">Select icon</option>
                                                    <option *ngFor="let opt of iconOptions" [value]="opt">{{opt}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <label for="title">Title</label>
                                                <input class="form-control" id="title" type="text"
                                                       [(ngModel)]="title" name="title">
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="d-flex justify-content-between align-items-center mb-1">
                                                <label class="mb-0">Description</label>
                                                <div class="btn-group" role="group">
                                                    <button type="button" class="btn btn-sm btn-outline-primary"
                                                            (click)="addEditorBlock('content')">
                                                        Content
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-outline-primary"
                                                            (click)="addEditorBlock('table')">
                                                        Table
                                                    </button>
                                                </div>
                                            </div>
                                            <ng-container *ngFor="let block of editorBlocks; let i = index">
                                                <div class="d-flex justify-content-end mb-1">
                                                    <button class="btn btn-icon btn-flat-danger" rippleEffect type="button"
                                                            title="Remove" (click)="removeEditorBlock(i)">
                                                        <i data-feather="trash-2"></i>
                                                    </button>
                                                </div>
                                                <quill-editor *ngIf="block.type === 'content'" class="university-info mb-3"
                                                              [(ngModel)]="block.value" name="quill-content-{{i}}"></quill-editor>

                                                <div *ngIf="block.type === 'table'" class="mb-3">
                                                    <editor [apiKey]="tinymceApiKey" [(ngModel)]="block.value" [init]="tableEditorInit"
                                                            name="table-content-{{i}}"></editor>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button class="btn btn-primary pull-right" rippleEffect (click)="addDetail()"
                                            [disabled]="submitting">
                                        <span class="font-weight-bold">Add</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-body">
                                <table class="table table-list">
                                    <thead>
                                    <tr>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Icon</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Title</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Description</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Sort Order</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody *ngIf="blocks && blocks.length > 0; else noDataToShowWeb">
                                    <tr *ngFor="let block of blocks">
                                        <td class="text-center">
                                            <h6 class="mt-1">{{block?.icon}}</h6>
                                        </td>
                                        <td class="text-center">
                                            <h6 class="mt-1">{{block?.title}}</h6>
                                        </td>
                                        <td class="text-center">
                                            <h6 class="mt-1" [innerHTML]="block?.description"></h6>
                                        </td>
                                        <td class="text-center">
                                            <h6 class="mt-1">{{block?.sort_order}}</h6>
                                        </td>
                                        <td class="text-center">
                                            <i class="fas fa-trash font-small-4 text-danger cursor-pointer"
                                               (click)="delete(block.id)"></i>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <ng-template #noDataToShowWeb>
                                        <tbody>
                                        <tr>
                                            <td class="text-center" colspan="5">
                                                <h6 class="mt-1">No data to show</h6>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </ng-template>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
